/**
 * Resolves a locality name from a geocoder suggestion's `address` breakdown.
 *
 * OpenCage/Nominatim-style responses commonly omit `city` for house-level
 * addresses, keying the locality under `town`/`village`/`municipality`/
 * `county` instead. Returns undefined (never a placeholder) when none of
 * the fields are present, since city is not a required field.
 */
export default function resolveCity (address) {
  if (!address) {
    return undefined;
  }

  return address.city || address.town || address.village || address.municipality || address.county || undefined;
}
